import { QueryClient } from '@tanstack/react-query';

import { isApiError } from './errors';

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 60_000,
      gcTime: 15 * 60_000,

      /**
       * Load-bearing in this app specifically.
       *
       * The SSE stream closes after the tab has been hidden for a minute (task B9), so
       * fixes arriving during that time are missed. A dispatcher who alt-tabs back after
       * twenty minutes must not stare at a stale map waiting for the next 10-minute
       * cycle. Focus refetch pulls an authoritative snapshot immediately, which is what
       * makes the pause/resume design correct rather than just cheap.
       */
      refetchOnWindowFocus: true,
      refetchOnReconnect: true,

      retry: (failureCount, error) => {
        if (!isApiError(error)) return failureCount < 2;
        if (error.code === 'CANCELLED') return false;
        // A 4xx will fail again identically; retrying just delays the error message.
        if (error.status >= 400 && error.status < 500) return false;
        return failureCount < 3;
      },
      retryDelay: (attempt) => Math.min(1000 * 2 ** attempt, 30_000),
    },
    mutations: {
      // A mutation is not safely idempotent in general -- a retried POST can create two
      // geofences. Retrying is the caller's decision, made per mutation.
      retry: 0,
    },
  },
});
